'use client';

interface MarketingSwiperArrowButtonProps {
  className: string;
  direction: 'prev' | 'next';
  hidden?: boolean;
  label: string;
  onClick?: () => void;
}

export function MarketingSwiperArrowButton({
  className,
  direction,
  hidden = false,
  label,
  onClick,
}: MarketingSwiperArrowButtonProps) {
  return (
    <button
      type="button"
      className={`${className} absolute top-1/2 z-[2] flex h-[32px] w-[32px] -translate-y-1/2 cursor-pointer items-center justify-center rounded-[50%] bg-black/40 opacity-0 transition-opacity group-hover:opacity-100 ${
        hidden ? 'hidden' : ''
      }`}
      aria-label={label}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="7"
        height="12"
        viewBox="0 0 7 12"
        fill="none"
        aria-hidden="true"
        className={direction === 'prev' ? 'rotate-180' : ''}
      >
        <path
          d="M0.21967 11.2803C-0.0732233 10.9874 -0.0732233 10.5126 0.21967 10.2197L4.689 5.75L0.21967 1.28033C-0.0465966 1.01406 -0.0708026 0.5974 0.147052 0.303788L0.21967 0.21967C0.512563 -0.0732231 0.987437 -0.0732231 1.28033 0.21967L6.28033 5.21967C6.57322 5.51256 6.57322 5.98744 6.28033 6.28033L1.28033 11.2803C0.987437 11.5732 0.512563 11.5732 0.21967 11.2803Z"
          fill="white"
        />
      </svg>
    </button>
  );
}
